/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Device } from '../../models/device';
import { DeviceCriteria } from '../../models/device-criteria';

export interface ApiMasterDeviceGetByCriteriaPost$Params {
      body?: DeviceCriteria
}

export function apiMasterDeviceGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterDeviceGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Device>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterDeviceGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Device>>;
    })
  );
}

apiMasterDeviceGetByCriteriaPost.PATH = '/api/Master/Device/GetByCriteria';
